export default __webpack_public_path__ + "static/media/input_image.0209efca.png";